import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { changeAmount } from "../reducers/actions";
import { IoCheckmark } from 'react-icons/io5';

class PriceSelector extends Component {

  constructor(props) {
    super(props);
    this.handleClickHOC = this.handleClickHOC.bind(this);
  }

  handleClickHOC(amount, price) {
    return () => {
      this.props.changeAmount(amount, price);
    };
  }

  render() {
    return (
      <div className="t-prices">
        <div className="t-price-selector">
          {this.props.prices.map((price, i) => (
            <div className={"t-price-item " + (price.amount === this.props.amount ? 'active' : '')} onClick={this.handleClickHOC(price.amount, price.price)}>
              <span className="amount">
                <span className="check"><IoCheckmark/></span> {price.amount}枚
              </span>
              <span className="price">{price.price}円<small>(税込)</small></span>
              <span className="unit">{price.unit}円/枚<small>(税込)</small></span>
            </div>
          ))}
        </div>
        <div className="t-price-total">
          <div className="t-price-view t-price-view-auto">
            送料無料
          </div>
          <div className="t-price-view">
            <small>加工費</small>
            <span>770円 <small>(税込)</small></span>
          </div>
          <div className="t-price-view t-price-view-primary">
            <small>合計</small>
            <span>{this.props.totalPrice}円 <small>(税込)</small></span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {changeAmount})(PriceSelector);